var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status != '*')?_c('v-btn',{attrs:{"block":"","dark":"","tile":"","depressed":"","color":_vm.getColor(_vm.status)}},[_vm._v(" "+_vm._s(_vm.status)+" ")]):_c('div',[_vm._v("*")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }